// import * as Ricon from "react-icons/md/index";
// import * as Iicon from "react-icons/io5/index";
import {
  MdArrowForward,
  MdArrowBack,
  MdMenu,
  MdSchedule,
  MdCheck,
  MdClose,
  MdChevronRight,
  MdAdd,
  MdArrowOutward,
  MdExpandMore,
  MdTune,
  MdCircle,
  MdExpandLess,
  MdFacebook,
  MdLink,
  MdShare,
  MdRemove,
} from "react-icons/md";

import { IoLogoTwitter, IoLogoLinkedin } from "react-icons/io5";

export const AllIcons = {
  MdArrowForward,
  MdArrowBack,
  MdMenu,
  MdCircle,
  MdSchedule,
  MdCheck,
  MdTune,
  MdExpandLess,
  MdClose,
  MdChevronRight,
  MdAdd,
  MdRemove,
  MdArrowOutward,
  MdExpandMore,
  MdShare,
  MdLink,
  MdFacebook,
  IoLogoTwitter,
  IoLogoLinkedin,
};
